<div *ngIf="enabled$ | async">
  <ng-container *ngIf="currentStatus$ | async as currentStatus">
    <button mat-button [matMenuTriggerFor]="menu">
      {{ statusesLabels[currentStatus] | transloco }}
      <span *ngIf="currentStatusTime$ | async">({{ currentStatusTime$ | async }})</span>
    </button>
    <mat-menu #menu="matMenu" [overlapTrigger]="false">
      <ng-container *ngFor="let status of availableStatuses$ | async">
        <button mat-menu-item [disabled]="status === currentStatus" (click)="changeCurrentStatus(status)">
          {{ statusesLabels[status] | transloco }}
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
</div>
